import script from "./category-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./category-detail.vue?vue&type=script&setup=true&lang=js"

import "./category-detail.vue?vue&type=style&index=0&id=77ca6272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ca6272"]])

export default __exports__